module.exports = __webpack_public_path__ + "static/img/logo.a40f9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 0